import { useEffect, useState } from "react";
import { api } from "./api";

/** Canonical entity and positioning language, read once from the backend and cached for the session. */
let cache = null;

export const useEntity = () => {
  const [d, setD] = useState(cache);

  useEffect(() => {
    if (cache) return;
    api
      .get("/entity")
      .then((r) => {
        cache = r.data;
        setD(r.data);
      })
      .catch(() => setD(null));
  }, []);

  return d;
};
